<template>
  <v-app-bar app dark color="blue">
    <v-toolbar-title>ST-COMM WEB APPLICATION</v-toolbar-title>

    <div class="flex-grow-1"></div>

    <v-toolbar-items>
      <v-btn :to="`/${customer}/home`" text>TOP</v-btn>
      <v-btn :to="`/${customer}/construction_sites`" text>現場図</v-btn>
      <v-btn :to="`/${customer}/devices`" text v-if="admin">DEVICES</v-btn>
      <v-btn :to="`/${customer}/users`" text v-if="admin">USERS</v-btn>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item to="release">
            <v-list-item-title>RELEASE</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="logout">
            <v-list-item-title>LOGOUT</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
export default {
  name: "app-header",
  props: {
    admin: { Type: Boolean, default: () => false },
  },
  computed: {
    customer() {
      return this.$route.params.customer;
    },
    isSystem() {
      return this.$store.state.user.role === "system";
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("user/logout").then(() => {
        this.$router.push(`/${this.customer}/login`);
      });
    },
  },
};
</script>
